export enum ExportType {
  ActivityLogging = "0",
  ActivityFeedbackLogging = "1",
  ActivityPlanning = "2",
}
